import {post} from './AgentSetup'

const register = data => post('RegisterDBs',data, false)

export default {
    register
}